import { AuthService } from './auth.service'
import {inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable, switchMap, take} from 'rxjs';
import {ROUTES} from '../../../routes.enum';

export function authAppInitializerFactory(authService: AuthService): () => Observable<void> {
  const activatedRoute =  inject(ActivatedRoute);
  return () => activatedRoute.url
    .pipe(
      take(1),
      switchMap(url => {
        // We want to make sure that we DO run the initial login sequence if we're on the public docket search page
        // WITHIN the app, but not if we're on the public docket search page OUTSIDE the app
        if (window.location.pathname.includes(ROUTES.APP) && window.location.pathname.includes(ROUTES.PUBLIC_DOCKET_SEARCH)) {
          return authService.runInitialLoginSequence();
        }
        // Don't run the initial login sequence if we're on the register or documents page
        else {
          if (!window.location.pathname.includes(ROUTES.REGISTER) &&
            !window.location.pathname.includes(ROUTES.DOCUMENTS) &&
            !window.location.pathname.includes(ROUTES.PUBLIC_DOCKET_SEARCH)) {
            return authService.runInitialLoginSequence();
          }
        }
        return Promise.resolve();
      }),
    )
  ;
}
